/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_ErrorInputs */

const en_contact_form_error = /** @type {(inputs: Contact_Form_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const lv_contact_form_error = /** @type {(inputs: Contact_Form_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Contact_Form_ErrorInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_error = /** @type {((inputs?: Contact_Form_ErrorInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_ErrorInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_error(inputs)
	return en_contact_form_error(inputs)
});